import React from 'react';
import { User } from 'lucide-react';

interface AnonymousIconProps {
  seed: string;
  className?: string;
}

export function AnonymousIcon({ seed, className = '' }: AnonymousIconProps) {
  // Generate a consistent color based on the seed
  const hue = React.useMemo(() => {
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash % 360;
  }, [seed]);

  return (
    <div 
      className={`rounded-full flex items-center justify-center bg-gradient-to-br ${className}`}
      style={{ 
        backgroundColor: `hsl(${hue}, 70%, 20%)`,
        backgroundImage: `linear-gradient(135deg, hsl(${hue}, 70%, 30%), hsl(${hue}, 70%, 15%))` 
      }}
    >
      <User className="w-4 h-4 text-white/90" />
    </div>
  );
}